import React from 'react';
import { useAntModalOkButton } from './hooks/useAntModalOkButton';
import { Box, Button, Typography } from '@mui/material';
import RobotError from './components/RobotError';

interface ErrorModalProps {
    title: string;
    message: string;
    onOk: () => void;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
    title,
    message,
    onOk,
}) => {
    const okButton = useAntModalOkButton();
    return (
        <Box
            height={'100%'}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            flexDirection={'column'}
        >
            <RobotError />
            <Box textAlign={'center'}>
                <Typography color="white" variant={'h6'}>
                    {title}
                </Typography>
                <Typography color="light" variant={'body2'} pb={2}>
                    {message}
                </Typography>
                <Button
                    onClick={() => {
                        onOk();
                        okButton?.current?.click();
                    }}
                    variant={'contained'}
                    color={'info'}
                >
                    Go back
                </Button>
            </Box>
        </Box>
    );
};
